import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.scss';
import MainRoutes from './common/component/MainRoutes';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <MainRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
